<template>
  <div class="container">
    <br>
    <button class="btn btn-primary btn-sm" @click="generatePDF()">下載 PDF</button>
    <br>
    <div class="detailtable table-responsive" ref="content">
      <table class="detailtable table table-bordered" style="text-align: center;">
        <thead>
          <tr>
            <th colspan="4" style="text-align: left;">
              <h3><b>運動習慣資訊整合診斷基本資料</b>
              </h3>
            </th>
          </tr>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 20px;">基本資料</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>填答日期</th>
            <th>姓名:</th>
            <th>年齡</th>
            <th>性別:</th>
          </tr>
          <tr>
            <td>{{ answerDate }}</td>
            <td>{{ name }}</td>
            <td>{{ age }}</td>
            <td>{{ gender }}</td>
          </tr>
        </tbody>
      </table>

      <table class="detailtable table table-bordered" style="text-align: center;" v-if="doctorSayNo != '1'">
        <thead>
          <tr>
            <th colspan="2" style="text-align: left;font-size: 20px;">評估結果</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>運動習慣階段分期</th>
            <td>{{ habitstageValue }}</td>
          </tr>
          <tr>
            <th>運動量計算</th>
            <td>{{ exerciseValue }} 運動量</td>
          </tr>
          <tr>
            <th>運動強度</th>
            <td>{{ intensity }}</td>
          </tr>
          <tr>
            <th>運動分級</th>
            <td>{{ activityLevelType }}</td>
          </tr>
        </tbody>
      </table>

      <table class="detailtable table table-bordered" v-if="doctorSayNo != '1'">
        <thead>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 20px;">運動診斷評語</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: left;" v-if="activityLevel == 'A'">
              你目前處在思考前期，沒有身體活動習慣，而且完全沒有運動行為的念頭。提醒你要立即思考改變不運動的想法與行為，因為根據過去的證據顯示：身體活動不足將危害到健康及正常器官的功能。導致：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">易有肌肉骨骼痠痛症狀</span></li>
                <li style="color:mediumblue;"><span style="color: black;">體力不足容易造成工作厭倦和疲勞</span></li>
                <li style="color:mediumblue;"><span style="color: black;">容易罹患慢性疾病</span></li>
                <li style="color:mediumblue;"><span style="color: black;">工作傷害機會增高</span></li>
                <li style="color:mediumblue;"><span style="color: black;">生病或受傷以致無法正常工作養家， 經濟收入減少影響家庭生活</span></li>
                <li style="color:mediumblue;"><span style="color: black;">對公司的人員派遣造成困擾</span></li>
                <li style="color:mediumblue;"><span style="color: black;">工作效率無法達成公司的要求</span></li>
                <li style="color:mediumblue;"><span style="color: black;">不健康的身體，將導致缺席家人 的人生重要階段（畢業，結婚 ... 等）</span></li>
              </ul>
              另一方面：研究也發現身體活動/健身運動能預防癌症、心血管疾病、新陳代謬疾病與身心症等慢性疾病。運動其實很簡單，您可從自己有興趣的運動項目開始，或從最簡易、不受時間、場地限制的健走開始，慢慢增加每次運動的時間，再加強每次運動的強度及次數。
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'B'">
              你目前處在思考前期，身體活動量不足，而且完全沒有運動行為的念頭。提醒你要立即思考改變不運動的想法與行為，因為根據過去的證據顯示：身體活動不足將危害到健康及正常器官的功能，導致：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">易有肌肉骨骼痠痛症狀</span></li>
                <li style="color:mediumblue;"><span style="color: black;">體力不足容易造成工作厭倦和疲勞</span></li>
                <li style="color:mediumblue;"><span style="color: black;">容易罹患慢性疾病</span></li>
                <li style="color:mediumblue;"><span style="color: black;">工作傷害機會增高</span></li>
                <li style="color:mediumblue;"><span style="color: black;">生病或受傷以致無法正常工作養家， 經濟收入減少影響家庭生活</span></li>
                <li style="color:mediumblue;"><span style="color: black;">對公司的人員派遣造成困擾</span></li>
                <li style="color:mediumblue;"><span style="color: black;">工作效率無法達成公司的要求</span></li>
                <li style="color:mediumblue;"><span style="color: black;">不健康的身體，將導致缺席家人 的人生重要階段（畢業，結婚 ... 等）</span></li>
              </ul>
              另一方面：研究也發現身體活動/健身運動能預防癌症、心血管疾病、新陳代謬疾病與身心症等慢性疾病。運動其實很簡單，您可從自己有興趣的運動項目開始，或從最簡易、不受時間、場地限制的健走開始，慢慢增加每次運動的時間，再加強每次運動的強度及次數。
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'C'">
              你目前處在思考期，沒有身體活動習慣，有想運動的念頭，但還沒開始。運動其實很簡單，您可從自己有興趣的運動項目開始，或從最簡易、不受時間、場地限制的健走開始，慢慢增加每次運動的時間，再加強每次運動的強度及次數。
              那如何轉換習慣呢？我們必須找出一種替代的慣性行為，如回家第一件事變成拿出水壺裝滿水，再換套輕便服裝騎上自行車出門去兜風，或者是看電視的時候，同時進行居家運動。如此轉變的行為模式，一旦新的慣性行為取代舊的慣性行為時，新的習慣就養成了，而舊的習慣也就被替換掉了。
              另一方面，建議改造自己的生活環境，讓自己更容易養成運動習慣。你可以這麼做：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">買雙慢跑鞋、自行車或健身用品等</span></li>
                <li style="color:mediumblue;"><span style="color: black;">在家門張貼運動日記，運動紀錄表</span></li>
                <li style="color:mediumblue;"><span style="color: black;">買只可紀錄燃燒卡路里數、步數和 心跳率等資料的運動型攜帶裝置</span></li>
                <li style="color:mediumblue;"><span style="color: black;">張貼叮嚀標語：與其吃藥打針花錢； 不如運動強身存本 / 改變從運動開始</span></li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'D'">
              你目前處在思考期，身體活動量不足，有想運動的念頭，但還沒開始。運動其實很簡單，您可從自己有興趣的運動項目開始，或從最簡易、不受時間、場地限制的健走開始，慢慢增加每次運動的時間，再加強每次運動的強度及次數。
              那如何轉換習慣呢？我們必須找出一種替代的慣性行為，如回家第一件事變成拿出水壺裝滿水，再換套輕便服裝騎上自行車出門去兜風，或者是看電視的時候，同時進行居家運動。如此轉變的行為模式，一旦新的慣性行為取代舊的慣性行為時，新的習慣就養成了，而舊的習慣也就被替換掉了。
              另一方面，建議改造自己的生活環境，讓自己更容易養成運動習慣。你可以這麼做：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">買雙慢跑鞋、自行車或健身用品等</span></li>
                <li style="color:mediumblue;"><span style="color: black;">在家門張貼運動日記，運動紀錄表</span></li>
                <li style="color:mediumblue;"><span style="color: black;">買只可紀錄燃燒卡路里數、步數和 心跳率等資料的運動型攜帶裝置</span></li>
                <li style="color:mediumblue;"><span style="color: black;">張貼叮嚀標語：與其吃藥打針花錢； 不如運動強身存本 / 改變從運動開始</span></li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'E'">
              你目前處在準備期，沒有規律身體活動習慣，想到時會運動一下，但一週不超過三天。運動其實很簡單，您可從自己有興趣的運動項目開始，或從最簡易、不受時間、場地限制的健走開始，慢慢增加每次運動的時間，再加強每次運動的強度及次數。你要做的就是要改變自己，拋除舊習慣，建立起新的運動習慣。
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">決心做出習慣的改變</span></li>
                <li style="color:mediumblue;"><span style="color: black;">養成新的慣性行為準備取代舊習慣</span></li>
                <li style="color:mediumblue;"><span style="color: black;">能站就不要坐；能跑就不要走</span></li>
                <li style="color:mediumblue;"><span style="color: black;">站、走、跑等動態行為取代躺、臥、 坐之靜態行為；走路或騎自行車替代騎車或搭車</span>
                </li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'F'">
              你目前處在準備期，身體活動量不足，想到時會運動一下，但一週不超過三天。國民健康署建議國人每天運動至少30分鐘，分段累積運動量，效果與一次做完一樣，不過每次至少要連續10
              分鐘。例如每天應至少運動30分鐘，可以拆成2次15分鐘，或3次10分鐘完成。你要做的就是要改變自己，拋除舊習慣，建立起新的運動習慣。
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">決心做出習慣的改變</span></li>
                <li style="color:mediumblue;"><span style="color: black;">養成新的慣性行為準備取代舊習慣</span></li>
                <li style="color:mediumblue;"><span style="color: black;">能站就不要坐；能跑就不要走</span></li>
                <li style="color:mediumblue;"><span style="color: black;">站、走、跑等動態行為取代躺、臥、 坐之靜態行為；走路或騎自行車替代騎車或搭車</span>
                </li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'G'">

              你目前處在行動期，身體活動量不足，每週保持運動至少三天 但運動習慣維持還不到6個月。國民健康署建議國人每天運動至少30分鐘，分段累積運動量，效果與一次做完一樣，不過每次至少要連續10
              分鐘。例如每天應至少運動30分鐘，可以拆成2次15分鐘，或3次10分鐘完成。
              建議運用下列方法來刺激運動習慣的維持：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">運動行為維持達一定天數或體脂肪下降就出去旅遊一次</span></li>
                <li style="color:mediumblue;"><span style="color: black;">決定參加一次5公里的馬拉松路跑</span></li>
                <li style="color:mediumblue;"><span style="color: black;">設立運動存錢筒：運動一次存50元， 直到積累一定金額後來購買新的運動用品獎勵自己</span>
                </li>
              </ul>
              找一些運動同好或參加俱樂部、健身運動社團等，以運動會友增進人際關係：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">參加社區或俱樂部的運動性社團</span></li>
                <li style="color:mediumblue;"><span style="color: black;">找一群志同道合的朋友籌組運動社團或隊伍</span></li>
              </ul>
              運用紀錄表來監控自己運動的情形：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">畫出目標達成階梯圖或運動記錄表</span></li>
                <li style="color:mediumblue;"><span style="color: black;">在家裡明顯處張貼標語</span></li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'H'">
              你目前處在行動期，身體活動量足夠，每週保持運動至少三天 但運動習慣維持還不到 6 個月。建議運用下列方法來刺激運動習慣的維持：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">運動行為維持達一定天數或體脂肪下降就出去旅遊一次</span></li>
                <li style="color:mediumblue;"><span style="color: black;">決定參加一次5公里的馬拉松路跑</span></li>
                <li style="color:mediumblue;"><span style="color: black;">設立運動存錢筒：運動一次存50元， 直到積累一定金額後來購買新的運動用品獎勵自己</span>
                </li>
              </ul>
              找一些運動同好或參加俱樂部、健身運動社團等，以運動會友增進人際關係：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">參加社區或俱樂部的運動性社團</span></li>
                <li style="color:mediumblue;"><span style="color: black;">找一群志同道合的朋友籌組運動社團或隊伍</span></li>
              </ul>
              運用紀錄表來監控自己運動的情形：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">畫出目標達成階梯圖或運動記錄表</span></li>
                <li style="color:mediumblue;"><span style="color: black;">在家裡明顯處張貼標語</span></li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'I'">
              你目前處在行動期，身體活動量優，每週保持運動至少三天 但運動習慣維持還不到 6 個月。建議運用下列方法來刺激運動習慣的維持：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">運動行為維持達一定天數或體脂肪下降就出去旅遊一次</span></li>
                <li style="color:mediumblue;"><span style="color: black;">決定參加一次5公里的馬拉松路跑</span></li>
                <li style="color:mediumblue;"><span style="color: black;">設立運動存錢筒：運動一次存50元， 直到積累一定金額後來購買新的運動用品獎勵自己</span>
                </li>
              </ul>
              找一些運動同好或參加俱樂部、健身運動社團等，以運動會友增進人際關係：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">參加社區或俱樂部的運動性社團</span></li>
                <li style="color:mediumblue;"><span style="color: black;">找一群志同道合的朋友籌組運動社團或隊伍</span></li>
              </ul>
              運用紀錄表來監控自己運動的情形：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">畫出目標達成階梯圖或運動記錄表</span></li>
                <li style="color:mediumblue;"><span style="color: black;">在家裡明顯處張貼標語</span></li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'J'">
              你目前處在維持期，每週保持運動至少三天 且運動習慣已維持 6
              個月以上，但身體活動量不足。雖然你已經養成健身運動的習慣，但應持續努力增加運動量。國民健康署建議國人每天運動至少30分鐘，分段累積運動量，效果與一次做完一樣，不過每次至少要連續10
              分鐘。例如每天應至少運動30分鐘，可以拆成2次15分鐘，或3次10分鐘完成。
              但是，一個人要持續養成良好的運動習慣，並非容易的事，過去研究發現大約有 4 成的運動者會發生故態復萌的情況，以下五招有助於讓你遠離故態復萌：
              <ul style="list-style-type: decimal; padding-left: 2.5em;">
                <li style="color:mediumblue;"><span style="color: black;">培養健身運動相關知識：建立正確的運動相關知識，使我們
                    越了解運動益處，對運動價值信念也會提高</span></li>
                <li style="color:mediumblue;"><span style="color: black;">找尋運動夥伴一起努力：互相激勵、可以參與更多元互動性的運動</span></li>
                <li style="color:mediumblue;"><span style="color: black;">多元運動創造運動時間：不局限在特定運動項目或場地</span></li>
                <li style="color:mediumblue;"><span style="color: black;">自我紀錄運動讓改變成真：設定目標，感受達成目標的成就感</span></li>
                <li style="color:mediumblue;"><span style="color: black;">適時降低標準增強信心：降低標準也能幫助我們獲得成功經驗，增強我們對於完成目標的信心</span>
                </li>
              </ul>
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'K'">
              你目前處在維持期，身體活動量足夠，每週保持運動至少三天，且運動習慣已維持 6
              個月以上。恭喜你已經養成健身運動的習慣，雖然健身運動會帶來非常多正面的效益，但我們也不能忽略健身運動可能帶來過度訓練與健身運動依賴的風險。因此，我們將介紹這兩個概念，並藉由填答檢測，評估自己目前的運動狀態，是不是處於健康的規律運動習慣喔！
              <br>
              <img src="@/assets/K1.jpg" style="width:600px;padding-left: 2.5em;">
              <br>
              檢測二 : 是否有健身運動依賴症狀
              請大家回想過去兩個禮拜當中的健身運動狀況，是否有以下狀況 :
              <br>
              <img src="@/assets/K2.jpg" style="width:600px;padding-left: 2.5em;">
              <br>
              研究指出個體因為沉迷在健身運動中，並影響到日常生活作息，這群人就叫做健身運動依賴者 (exercise
              dependence)，這些個體會將運動視為生活中最重要的事，而排斥其他社交活動，如沒有在24-36小時內繼續運動，就會產生生理心理退縮的現象，如退縮、沮喪、便秘、易怒、痠痛或肌肉緊張等。建議運用下列策略來降低健身運動依賴風險：1.避免從事單一運動，多元運動滿足需求，2.安排合理的休息期，3.安排較舒壓的運動型態，如放鬆、瑜珈、太極或冥想。
            </td>
            <td style="text-align: left;" v-else-if="activityLevel == 'L'">
              你目前處在維持期，身體活動量優，每週保持運動至少三天 且運動習慣已維持 6
              個月以上。恭喜你已經養成健身運動的習慣，雖然健身運動會帶來非常多正面的效益，但我們也不能忽略健身運動可能帶來過度訓練與健身運動依賴的風險。因此，我們將介紹這兩個概念，並藉由填答檢測，評估自己目前的運動狀態，是不是處於健康的規律運動習慣喔！
              <br>
              <img src="@/assets/K1.jpg" style="width:600px;padding-left: 2.5em;">
              <br>
              檢測二 : 是否有健身運動依賴症狀
              請大家回想過去兩個禮拜當中的健身運動狀況，是否有以下狀況 :
              <br>
              <img src="@/assets/K2.jpg" style="width:600px;padding-left: 2.5em;">
              <br>
              研究指出個體因為沉迷在健身運動中，並影響到日常生活作息，這群人就叫做健身運動依賴者 (exercise
              dependence)，這些個體會將運動視為生活中最重要的事，而排斥其他社交活動，如沒有在24-36小時內繼續運動，就會產生生理心理退縮的現象，如退縮、沮喪、便秘、易怒、痠痛或肌肉緊張等。建議運用下列策略來降低健身運動依賴風險：1.避免從事單一運動，多元運動滿足需求，2.安排合理的休息期，3.安排較舒壓的運動型態，如放鬆、瑜珈、太極或冥想。
            </td>
            <td style="text-align: left;" v-else>
              無符合條件
            </td>
          </tr>
        </tbody>
      </table>

      <table class="detailtable table table-bordered" v-if="doctorSayNo == '1'">
        <thead>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 20px;">轉介建議</th>
          </tr>
          <tr>
            <td colspan="4" style="text-align: left;font-size: 18px;">醫院診所</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="4" style="text-align: left;">
              建議至醫療診所進行專業醫療診斷與疾病確定並定期追蹤治療。
            </td>
          </tr>
        </tbody>
      </table>

      <table class="detailtable table table-bordered" style="text-align: left;"
        v-else-if="age >= 65 && noRecommend != '1' && doctorSayNo != '1'">
        <thead>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 20px;">轉介建議</th>
          </tr>
          <tr>
            <td colspan="4" style="text-align: left;">
              不老健身房 :
              <br>
              人不要等到失智、失能才來就醫治療，都為時已晚，透過「不老健身房」來鍛鍊肌力，
              有醫生風險評估並有專業教練一對一指導，讓年長者可安全的在健身房訓練、增強肌力，以預防衰弱、跌倒並延緩失能發生機率。
            </td>
          </tr>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 18px;">推薦您住家附近的不老健身房</th>
          </tr>
          <tr>
            <th style="width:30%;text-align: center;">名稱</th>
            <th style="width:50%;text-align: center;">地址</th>
            <th style="width:10%;text-align: center;">開放時段</th>
            <th style="width:10%;text-align: center;">電話</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr v-for="(gym, index) in filteredGyms" :key="index">
            <td colspan="4" >

              <div v-for="(area, areaIndex) in gym.AreaList" :key="areaIndex">
                {{ area.Place }}
                {{ gym.CityName }}{{ area.AreaName }}{{ area.RoadName }}
                {{ area.OpenTime }}
                {{ area.Phone }}
              </div>
            </td>
        
          </tr> -->
          <template v-if="filteredGyms.length !== 0">
            <tr v-for="(gym, index) in filteredGyms" :key="index">
              <td>{{ gym.Place }}</td>
              <td>{{ formDataJson.selectedCity }}{{ gym.AreaName }}{{ gym.RoadName }}</td>
              <td>{{ gym.OpenTime }}</td>
              <td>{{ gym.Phone }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="4" style="text-align: left;"> {{ formDataJson.selectedCity }}尚未有合作單位，建議您可搜尋
                {{ formDataJson.selectedCity }} 不老健身房，尋找適合的單位聯繫</td>
            </tr>
          </template>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 18px;">醫院診所</th>
          </tr>
          <tr>
            <td colspan="4" style="text-align: left;">
              建議至醫療診所進行專業醫療診斷與疾病確定並定期追蹤治療。
            </td>
          </tr>
          <tr v-if="metabolism == '1' && doctorSayNo != '1'">
            <th colspan="4" style="text-align: left;font-size: 18px;">代謝症候群轉介建議</th>
          </tr>
          <tr>
            <td colspan="4" style="text-align: left;">
              {{ formDataJson.selectedCity }}尚未有合作單位，建議您可搜尋 {{ formDataJson.selectedCity }} 代謝症候群門診，尋找適合的醫療院所
            </td>
          </tr>
        </tbody>
      </table>
      <table class="detailtable table table-bordered" v-else-if="metabolism == '1' && doctorSayNo != '1'">
        <thead>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 20px;">轉介建議</th>
          </tr>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 18px;">代謝症候群轉介建議</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="4" style="text-align: left;">
              {{ formDataJson.selectedCity }}尚未有合作單位，建議您可搜尋 {{ formDataJson.selectedCity }} 代謝症候群門診，尋找適合的醫療院所
            </td>
          </tr>
        </tbody>
      </table>
      <table class="detailtable table table-bordered" v-else>
        <thead>
          <tr>
            <th colspan="4" style="text-align: left;font-size: 20px;">轉介建議</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="4" style="text-align: left;">您不適用
            </td>
          </tr>
        </tbody>
      </table>
     
    </div>
    <table class="detailtable table">
        <tbody>
          <tr>
            <th>
              <p>填單者編號:{{ userId }}</p>
            </th>
            <th><button class="btn btn-primary btn-sm" @click="generatePDF()">下載 PDF</button></th>
            <th><button @click="goHomePage()" class="btn btn-primary btn-sm">回清單</button></th>
            <th><button @click="isShowUserFormData = !isShowUserFormData" class="btn btn-primary btn-sm">檢視問卷內容</button></th>
          </tr>
        </tbody>
      </table>
    <div v-if="isShowUserFormData" class="userForm">
      <hr>
      <p>填單日期時間: {{ answerDateTime }}</p>
      <div >
      <h3 class="mb-4" >基本資料 <span style="font-size: 14px;color: gray;">Page 1</span></h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="name" v-model="formData.name" :disabled="isReadOnly" />
            <label class="floating-label" for="name">姓名</label>
          </div>
          <div class="form-floating mb-3">
            <select class="form-control" id="gender" v-model="formData.gender" :disabled="isReadOnly">
              <option value="male">男</option>
              <option value="female">女</option>
            </select>
            <label class="floating-label" for="gender">性別</label>
          </div>
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="age" v-model="age" :disabled="isReadOnly" />
            <label class="floating-label" for="age">年齡</label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="city" v-model="formData.selectedCity" :disabled="isReadOnly" />
            <label class="floating-label" for="city">縣市</label>
          </div>
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="district" v-model="formData.selectedDistrict" :disabled="isReadOnly" />
            <label class="floating-label" for="district">地區</label>
          </div>
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="road" v-model="formData.selectedRoad" :disabled="isReadOnly" />
            <label class="floating-label" for="road">路名</label>
          </div>
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="address" v-model="formData.address" :disabled="isReadOnly" />
            <label class="floating-label" for="address">地址</label>
          </div>
        </div>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">基本資料 <span style="font-size: 14px;color: gray;">Page 2</span></h3>
      <div class="mb-3">
        <div class="form-floating">
          <select class="form-control" id="education" v-model="formData.education" :disabled="isReadOnly">
            <option value="unknown">未知</option>
            <option value="elementary">國小</option>
            <option value="junior_high">國中</option>
            <option value="high_school">高中</option>
            <option value="college">大學/專科</option>
            <option value="graduate">研究所以上</option>
          </select>
          <label class="floating-label" for="education">教育程度</label>
        </div>
      </div>
      <div class="mb-3">
        <div class="form-floating">
        <input type="text" class="form-control" id="occupation" v-model="formData.occupation" :disabled="isReadOnly" />
        <label class="floating-label" for="occupation">職業</label>
        </div>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">基本資料 <span style="font-size: 14px;color: gray;">Page 3</span></h3>
      <div class="mb-3">
        <p class="mb-2">自覺健康狀態: {{ formData.iconRate }}</p>
        <span>(由1到10代表自覺健康狀態，分數越高健康越好)</span>
        <input class="form-range "  v-model="formData.iconRate" type="range" min="0" max="10" id="iconRate"   :disabled="isReadOnly" />
      </div>
      <div class="mb-3">
        <label for="other" class="form-label">其他</label>
        <textarea class="form-control custom-textarea" id="other" v-model="formData.other" placeholder="" rows="5"  :disabled="isReadOnly"></textarea>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">基本疾病調查 <span style="font-size: 14px;color: gray;">Page 4</span></h3>
      <div class="mb-3">
        <!-- <label class="form-label">您沒有運動的原因是什麼？（最多選擇三個）</label> -->
        <label class="form-check" v-for="reason in reasons" :key="reason">
          <input class="form-check-input" type="checkbox" v-model="formData.selectedReasons" :value="reason"
          v-bind:disabled="isReadOnly" />
          {{ reason }}
        </label>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">運動習慣 <span style="font-size: 14px;color: gray;">Page 5</span></h3>
      <div class="mb-3">
        <div class="mb-2">
          <p>我最近有在運動：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.recentExercise" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.recentExercise" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>我打算在未來6個月內運動：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.futureExercise" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.futureExercise" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>我最近有在做規律運動，每周至少三次：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.regularExercise" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.regularExercise" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>我規律地在做運動已超過6個月：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.longTermExercise" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.longTermExercise" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <br />
      </div>
    </div>
    <div>
      <h3 class="mb-4">運動習慣-過去六個月內 <span style="font-size: 14px;color: gray;">Page 6</span></h3>
      <div class="mb-3">
        <label class="form-label">您每週平均運動幾次？</label>
        <input class="form-control custom-input"
          style="width: 60px !important; text-align: center;margin-left: 10px; margin-right: 10px;" v-model="formData.exerciseFrequency"
          type="text"  :disabled="isReadOnly" />
      </div>
      <div class="mb-3" style="display: flex; align-items: center;">
        <label class="form-label">您每次運動平均多久時間？ </label>
        <input class="form-control custom-input"
          style="width: 60px !important; text-align: center;margin-left: 10px; margin-right: 10px;" v-model="formData.exerciseDuration"
          type="text"  :disabled="isReadOnly" /><span>分鐘</span>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">運動習慣-過去六個月內 <span style="font-size: 14px;color: gray;">Page 7</span></h3>
      <div class="mb-3">
        <label class="form-label">您運動的激烈程度？</label>
        <select class="form-select custom-select" v-model="formData.intensity"  :disabled="isReadOnly">
          <option value="light">輕鬆不喘(輕)</option>
          <option value="moderate">微喘流汗(中)</option>
          <option value="intense">急喘暴汗(強)</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">您最常做哪些運動？</label>
        <label class="form-check" v-for="activity in activities" :key="activity">
          <input class="form-check-input" type="checkbox" v-model="formData.selectedActivities" :value="activity" :disabled="isReadOnly" />
          {{ activity }}
        </label>
      </div>
      <div class="mb-3">
        <label class="form-label">您通常運動的場所為何？</label>
        <label class="form-check" v-for="place in places" :key="place">
          <input class="form-check-input" type="checkbox" v-model="formData.selectedPlaces" :value="place" :disabled="isReadOnly" />
          {{ place }}
        </label>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">無運動習慣 <span style="font-size: 14px;color: gray;">Page 8</span></h3>
      <div class="mb-3">
        <label class="form-label">您沒有運動的原因是什麼？（最多選擇三個）</label>
        <label class="form-check" v-for="reason8 in reasons8" :key="reason8">
          <input class="form-check-input" type="checkbox" v-model="formData.selectedReasons8" :value="reason8"
          v-bind:disabled="isReadOnly" />
          {{ reason8 }}
        </label>
      </div>
      <br>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import gymData from "@/assets/gymData.json";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export default {
  name: 'DetailPage',
  data() {
    return {
      isDev: window.VUE_APP_Dev,
      linecode: '',
      gymData: gymData,
      PK: '',
      SK: '',
      answerDateTime:'',
      answerDate: this.getCurrentDate(),
      name: '',
      age: null,
      gender: '',
      stageValue: '',
      intensity: '',
      activityLevel: '', //運動行為分期與身體活動量分級組合
      activityLevelType: '', //運動分級
      habitstageValue: '',
      metabolism: '',//代謝症候群建議
      noRecommend: '',//暫列高危險群,排除轉介運動
      doctorSayNo: '', //暫列高危險群,排除轉介運動
      exerciseValue: 0,
      formData: {},
      userLoginType: '',
      userId: '',
      formDataJson: null,
      isShowUserFormData : false,
      isReadOnly: true,
      reasons: ['心臟病', '代謝性症候群(高血壓、高血脂、高血糖)', '醫師囑咐不可運動', '曾經在半年內發生跌倒', '在半年內曾因跌倒而失去意識', '無'],
      exerciseFrequencyOptions: [
        { label: '0', value: '0' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '7', value: '7' }
      ],
      activities: ['有氧運動 (爬山、快走、廣場舞、有氧舞蹈、游泳、球類運動)', '肌力運動 (彈力帶、啞鈴、阻力訓練肌)', '拉筋運動 (毛巾操、拍打功、氣功)', '太極拳', '其他？'],
      places: ['戶外地點', '附近社區', '居家'],
      reasons8: ['工作因素', '身體因素', '家庭因素', '心理因素', '環境因素', '經濟因素'],

    };
  },
  beforeMount() {
    this.userLoginType = localStorage.getItem("userLoginType");
    this.linecode = localStorage.getItem("linecode");
   
    if (this.isDev != '1') {
      if (!this.linecode) {
        this.$router.push({ name: "HomePage" });
      }
    }
  },
  created() {

    if (this.$route.query.PK) {
      this.PK = this.$route.query.PK;
    }
    if (this.$route.query.SK) {
      this.SK = this.$route.query.SK;
    }
    this.fetchData();

  },
  computed: {
    filteredGyms() {
      // 客人地址資訊
      const customerCity = this.formDataJson.selectedCity;
      const customerDistrict = this.formDataJson.selectedDistrict;
      let filteredGyms = [];
      // 過濾相同縣市和區域的健身房資料
      const filteredGymsCity = this.gymData.filter((gym) => gym.CityName === customerCity);
      if (filteredGymsCity.length > 0) {
        filteredGyms = filteredGymsCity[0].AreaList.filter((area) => area.AreaName === customerDistrict);
        // 如果資料不足五筆，自動從同一個縣市的健身房資料中取得，湊滿五筆
        if (filteredGyms.length < 5) {
          filteredGymsCity[0].AreaList.filter((area) => area.AreaName != customerDistrict).forEach((area) => {
            if (filteredGyms.length >= 5) {
              return;
            } else {
              filteredGyms.push(area);
            }
          });
        }
      }
      return filteredGyms;
    }
  },
  mounted() {
    this.answerDateTime = this.convertTimestampToDate();
  },
  methods: {
    async generatePDF() {
      const element = this.$refs.content;

      // 确保在转换为 Canvas 时保持原始尺寸
      const canvas = await html2canvas(element, {
        scrollY: -window.scrollY,
        scale: 1 // 使用 1 的缩放比例来保持原始尺寸
      });
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: 'a4'
      });

      const margin = 10; // 边距
      const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin; // 减去左右边距
      const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * margin; // 减去上下边距

      // 计算基于 PDF 页面宽度的缩放后的图像高度
      const imgProps = pdf.getImageProperties(imgData);
      const scaledWidth = pdfWidth;
      const scaledHeight = imgProps.height * scaledWidth / imgProps.width;

      let position = 0;

      // 分割并添加页面
      while (position < scaledHeight) {
        // 计算当前页的图像部分
        const heightOnPage = Math.min(scaledHeight - position, pdfHeight);
        
        // 添加图像的当前部分到 PDF
        pdf.addImage(imgData, 'PNG', margin, -position + margin, scaledWidth, scaledHeight);
        
        position += heightOnPage;

        // 检查是否还有更多内容需要在新的页面上渲染
        if (position < scaledHeight) {
          pdf.addPage();
        }
      }

      pdf.save('behavior.pdf');
    },
    convertTimestampToDate() {
      return new Date(this.SK * 1000).toLocaleString();
    },
    goHomePage() {
      this.$router.push({ name: "HomePage" });
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    },
    fetchData() {
      // 使用axios呼叫API，傳入PK和SK作為參數
      axios
        .get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/get_data', {
          params: {
            PK: this.PK,
            SK: this.SK,
          },
        })
        .then((response) => {
          const data = response.data;
          this.formData = data.form_data;

          // 解析result_data並將數據綁定到頁面上
          this.answerDate = data.result_data.answerDate;
          this.name = data.result_data.name;
          this.age = data.result_data.age;
          this.gender = data.result_data.gender;
          this.habitstageValue = data.result_data.habitstageValue;
          this.intensity = data.result_data.intensity;
          this.exerciseValue = data.result_data.exerciseValue;
          this.noRecommend = data.result_data.noRecommend;
          this.doctorSayNo = data.result_data.doctorSayNo;
          this.metabolism = data.result_data.metabolism;
          this.activityLevel = data.result_data.activityLevel;
          this.activityLevelType = data.result_data.activityLevelType;
          const parts = data.PK.split("_");
          this.userId = parts[1];     // 取得"user123"
          this.formDataJson = data.form_data;

          // 如果有其他數據需要解析，可以在這裡添加
        })
        .catch((error) => {
          console.error(error);
        });
    },

  },
};
</script>

<style>
@media (max-width: 768px) {
  table {
    width: 100%;
  }

  .table-responsive {
    overflow-x: auto;
  }
}

/* 在這裡放置您的 CSS 样式 */
body {
  font-family: 'Arial', sans-serif;
  background-color: #EFEDE6 !important;
  /* margin: 20px; */
}
.detailtable {
  width: 100%;
  background-color: #EFEDE6 !important;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.info-box {
  padding: 10px;
  margin-bottom: 20px;
}

.detailtable th,
.detailtable td {
  background-color: #EFEDE6 !important;
  padding: 10px;
  text-align: center;
}

.detailtable th {
  background-color: #EFEDE6 !important;
  font-weight: bold;
}

.table-bordered {
  border: 1px solid #c5c3be !important; /* 邊框使用暖灰色 */

}

.feedback-header {
  font-size: 1.1em;
  font-weight: 800;
  margin-bottom: 10px;
}

.bd-code-snippet {
  /* width: 200mm !important; */
  border-width: 1px;
  border-radius: var(--bs-border-radius);
  border: solid var(--bs-border-color);
}
.btn-primary {
  background-color: #CC785C !important; /* 按鈕使用銅紅色 */
  border-color: #D3A17E !important; /* 按鈕邊框使用淡粉棕色 */
  color: #EFEDE1 !important; /* 按鈕文字使用象牙色 */
}

.btn-primary:hover {
  background-color: #D3A17E !important; /* 鼠標懸停時的按鈕背景色 */
  border-color: #CC785C !important; /* 鼠標懸停時的按鈕邊框色 */
}
</style>